// Secure-ish token storage. Office.js runs inside an iframe where
// localStorage is per-origin and survives taskpane reloads. For production
// hardening we should migrate to Office.Dialog + refresh-in-memory only,
// but Phase 2 scope keeps things simple.

const ACCESS_KEY = 'ubinex.access_token';
const REFRESH_KEY = 'ubinex.refresh_token';
const USER_KEY = 'ubinex.user';

export const storage = {
  getAccess(): string | null {
    return localStorage.getItem(ACCESS_KEY);
  },
  getRefresh(): string | null {
    return localStorage.getItem(REFRESH_KEY);
  },
  getUser<T = unknown>(): T | null {
    const raw = localStorage.getItem(USER_KEY);
    try {
      return raw ? (JSON.parse(raw) as T) : null;
    } catch {
      return null;
    }
  },
  setTokens(access: string, refresh: string) {
    localStorage.setItem(ACCESS_KEY, access);
    localStorage.setItem(REFRESH_KEY, refresh);
  },
  setUser(user: unknown) {
    localStorage.setItem(USER_KEY, JSON.stringify(user));
  },
  clear() {
    localStorage.removeItem(ACCESS_KEY);
    localStorage.removeItem(REFRESH_KEY);
    localStorage.removeItem(USER_KEY);
  },
};
